import { useSiteConfigStore } from '@/stores/config/site'

export function useProductAdapter({
  product,
  hideDiscount = false,
  isClientFastenal = false,
  isAgreementState = false
}) {
  const siteConfigStore = useSiteConfigStore()
  const productImageConfig = siteConfigStore.getProductConfigImage

  return {
    ...product,
    icons: getDynamicIcons(
      product,
      productImageConfig,
      hideDiscount,
      isClientFastenal,
      isAgreementState
    )
  }
}

function getDynamicIcons(
  product,
  productImageConfig,
  hideDiscount,
  isClientFastenal,
  isAgreementState
) {
  return [
    {
      type: 'image',
      src: '', // Usar la imagen reactiva
      alt: 'Brand Image',
      class: 'img-fluid brand-image-width-card',
      position: productImageConfig?.brandIcon?.position,
      tooltip: 'Marca',
      state: productImageConfig?.brandIcon?.state && product.brand // Mostrar solo si la imagen está disponible
    },
    {
      type: 'badge',
      content: 'F',
      bgClass: 'text-bg-primary',
      position: productImageConfig?.fastenalIcon?.position,
      tooltip: 'Fastenal',
      state:
        productImageConfig?.fastenalIcon?.state && product.fastenal_part_num && isClientFastenal
    },
    {
      type: 'badge',
      content: 'AGOTADO',
      bgClass: 'text-danger',
      tooltip: 'Agotado',
      state: isAgreementState && (product.sold_out || product.stock <= 0)
    },
    {
      type: 'fontawesome',
      icon: ['fas', 'tags'],
      iconClass: 'text-danger',
      text: `${product.discount}%`,
      textClass: 'text-white',
      transform: 'shrink-12 up-1 down-1',
      position: productImageConfig?.discountTag?.position,
      tooltip: `${product.discount}% de descuento`,
      state:
        productImageConfig?.discountTag?.state &&
        product.discount > 0 &&
        !product.sold_out &&
        !hideDiscount
    }
  ].filter((icon) => icon.state)
}
